import { FunctionComponent } from "react";

import MaconiaAppLogo from "@/assets/images/maconia-logo.png";

export const MaconiaLogo: FunctionComponent<{ handleClick?: () => void }> = ({ handleClick }) => {
	return (
		<div className="flex items-center justify-center h-[32px] w-fit ">
			<img
				alt="logo"
				className=" h-full cursor-pointer z-40 text-primary-blue"
				src={`${MaconiaAppLogo}`}
				onClick={() => handleClick?.()}
			/>
		</div>
	);
};
